// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22fPk","footer":"styles_footer__1x-CB","passCodeTooltip":"styles_passCodeTooltip__32OBS"};